import { connect } from 'react-redux'
import { doRememberPreviousMailbox } from 'actions/mailboxes'
import { selectMailboxes } from 'selectors/mailboxes_base'
import View from './view'

const select = state => {
  return { mailboxes: selectMailboxes(state) }
}

const perform = {
  doRememberPreviousMailbox,
}

export default connect(select, perform)(View)
